import React from 'react';

export default function AwardIcon({ width = 17, height = 26, fill = '#FFFFFF' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17 26"
      fill="none"
    >
      <path
        d="M8.5 0.5C13.1023 0.5 16.8328 4.23078 16.833 8.83301C16.833 11.5301 15.5505 13.9261 13.5635 15.4492L14.7412 24.3213C14.7938 24.7178 14.6146 25.1095 14.2803 25.3291C13.9461 25.5486 13.5158 25.5571 13.1729 25.3516L8.5 22.5479L3.82715 25.3516C3.48423 25.5571 3.05393 25.5486 2.71973 25.3291C2.38545 25.1095 2.20618 24.7178 2.25879 24.3213L3.43652 15.4502C1.44921 13.9271 0.166992 11.5303 0.166992 8.83301C0.167168 4.23078 3.89774 0.5 8.5 0.5ZM11.6094 16.5645C10.6483 16.9513 9.59951 17.167 8.5 17.167C7.40049 17.167 6.35168 16.9513 5.39062 16.5645L4.6084 22.4531L7.96387 20.4404C8.29375 20.2425 8.70625 20.2425 9.03613 20.4404L12.3916 22.4531L11.6094 16.5645ZM8.5 2.58301C5.04833 2.58301 2.25018 5.38138 2.25 8.83301C2.25 12.2848 5.04822 15.083 8.5 15.083C9.7187 15.083 10.855 14.7331 11.8164 14.1299C11.857 14.0989 11.9001 14.0708 11.9453 14.0459C13.6346 12.9271 14.75 11.011 14.75 8.83301C14.7498 5.38138 11.9517 2.58301 8.5 2.58301Z"
        fill={fill}
      />
    </svg>
  );
}
